import { Empty, Form, Spin, Table, DatePicker } from "antd";
import { useState } from "react";
import { Typography } from "antd";
import { getRequest } from "../../../http/axiosConfig/config";
import urls from "../../../http/endpoints/urls";
import swal from "sweetalert2";

export default function Anurag() {
  const [selectedDate, setSelectedDate] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [displayDate, setDisplayDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const customerId = localStorage.getItem("userId");
  const [dateForm] = Form.useForm();
  const { Title } = Typography;

  const getPaymentStatus = async () => {
    try {
      const formattedDate = selectedDate.format("DD-MMM-YYYY");
      const res = await getRequest(
        urls.getpaymentStatusByDate(customerId, formattedDate),
      );
      if (res.status === "success") {
        setDisplayDate(selectedDate ? selectedDate.format("DD-MMM-YYYY") : "");
        setTransactions(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleOrderClick = async (record) => {
    const res = await getRequest(
      urls.verify_payment_webapp_order_id(record.order_id),
    );
    if (res.status === 0) {
      swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    } else {
      swal.fire({
        title: "Success",
        text: res.message,
        icon: "success",
      });
    }
    getPaymentStatus();
  };

  const onlineTransactionsColumns = [
    { title: "Order Id", dataIndex: "order_id", width: 110, hidden: true },
    {
      title: "Time",
      dataIndex: "initiated_tm",
      width: 40,
      align: "center",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      width: 40,
      align: "right",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 50,
      align: "center",
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 50,
      align: "center",
      render: (_, record) => {
        const isSuccess = record.status === "SUCCESS";
        return (
          <button
            disabled={isSuccess}
            onClick={() => !isSuccess && handleOrderClick(record)}
            style={{
              padding: "4px 10px",
              borderRadius: "4px",
              border: "none",
              cursor: isSuccess ? "not-allowed" : "pointer",
              backgroundColor: isSuccess ? "#d9d9d9" : "#23b0fc",
              color: isSuccess ? "#888" : "white",
              fontWeight: 500,
              display: isSuccess ? "none" : "block",
              margin: "0 auto",
            }}
          >
            Verify
          </button>
        );
      },
    },
  ].filter((col) => !col.hidden);

  return (
    <div>
      <Form
        className="date-range-form"
        form={dateForm}
        layout={"horizontal"}
        onFinish={getPaymentStatus}
        requiredMark={false}
        style={{
          marginTop: 10,
          marginBottom: 10,
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <Form.Item
          noStyle
          name={"date"}
          rules={[{ required: true, message: "Please select a date" }]}
        >
          <DatePicker
            placeholder="Select Date"
            format="DD-MM-YYYY"
            style={{ width: "169px" }}
            onChange={(date) => {
              setSelectedDate(date);
            }}
          />
        </Form.Item>

        {selectedDate && (
          <Form.Item noStyle>
            <button
              style={{
                width: 60,
                padding: 7,
                backgroundColor: "#1890ff",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                marginLeft: 8,
                boxShadow: "none",
              }}
              onClick={() => dateForm.submit()}
            >
              Go
            </button>
          </Form.Item>
        )}
      </Form>

      {!loading && transactions ? (
        <>
          <Title level={5} style={{ textAlign: "center" }}>
            Payments on {displayDate}
          </Title>
          <Table
            size="small"
            dataSource={loading ? [] : transactions}
            locale={{
              emptyText: loading ? <Spin /> : <Empty />,
            }}
            columns={onlineTransactionsColumns}
            scroll={{ y: "calc(100vh - 350px)", x: 100 }}
            pagination={false}
            style={{
              border: "1px solid black",
              borderRight: "2px solid black",
            }}
          />
        </>
      ) : null}

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : null}
    </div>
  );
}
